<template>
  <section id="team" class="section-container">
    <div v-reveal class="section-content">
      <h2 class="section-title">Team</h2>

      <a-card class="authors-panel">
        <p class="lead-authors" aria-label="Core authors">
          <strong>Core Authors:</strong>
          <span class="author-person">
            <span class="author-name">Le Cong</span>
            <span class="author-affiliation">Stanford</span>
          </span>
          <span class="author-separator" aria-hidden="true"></span>
          <span class="author-person">
            <span class="author-name">Mengdi Wang</span>
            <span class="author-affiliation">Princeton</span>
          </span>
        </p>

        <p class="contributors-text">
          <strong>Co-first Contributors:</strong> Zaixi Zhang, Xiaotong Wang, Yin Di, Ruofan Jin,
          Michal Gerasimiuk, Yinkai Wang, Ravi K. Dinesh, David Smerkous, Alex Smerkous,
          Xuekun Wu, Shilong Liu, Peishan Li, Yi Zhu, Simran Serrao, Ning Zhao,
          Imran A. Mohammad, John B. Sunwoo, and Joseph C. Wu.
        </p>

        <div class="author-list-block">
          <div class="author-list-title">
            <span class="author-list-arrow" aria-hidden="true"></span>
            <span>View full author listing & affiliations</span>
          </div>
          <div class="affiliations-text">
            Le Cong¹²*, Zaixi Zhang³*, Xiaotong Wang¹²*, Yin Di¹²*, Ruofan Jin³,
            Michal Gerasimiuk¹², Yinkai Wang¹², Ravi K. Dinesh¹², David Smerkous⁴,
            Alex Smerkous⁵, Xuekun Wu²⁶, Shilong Liu³, Peishan Li¹², Yi Zhu¹²,
            Simran Serrao¹², Ning Zhao¹², Imran A. Mohammad²⁷, John B. Sunwoo²⁷,
            Joseph C. Wu²⁶, Mengdi Wang³**.
            <br><em>(See paper for full institutional details.)</em>
          </div>
        </div>
      </a-card>
    </div>
  </section>
</template>

<script setup lang="ts">
import { vReveal } from '@/directives/reveal'
</script>

<style scoped>
.section-container {
  padding: 72px 0;
  background: #ffffff;
}

.section-content {
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: 30px;
  margin: 0 0 16px;
  color: #6366f1;
  font-weight: 600;
  letter-spacing: 0;
}

.authors-panel {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #eef2ff;
  border-radius: 16px;
  box-shadow: 0 8px 28px rgba(16, 24, 40, 0.08);
}

.authors-panel::before {
  content: '';
  position: absolute;
  inset: 0 0 auto;
  height: 2px;
  background: linear-gradient(90deg, rgba(139, 92, 246, 0.82) 0%, rgba(34, 211, 238, 0.82) 100%);
}

.authors-panel :deep(.ant-card-body) {
  padding: 30px 40px 28px;
}

.lead-authors {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px 10px;
  min-width: 0;
  margin: 0 0 12px;
  color: #1f2937;
  font-size: 16px;
  line-height: 1.6;
}

.lead-authors strong {
  font-weight: 700;
}

.author-person,
.author-separator {
  display: inline-flex;
}

.author-person {
  align-items: baseline;
  gap: 6px;
}

.author-name {
  color: #111827;
  font-weight: 700;
}

.author-affiliation {
  align-items: center;
  color: #64748b;
  font-size: 15px;
  font-weight: 500;
}

.author-affiliation::before {
  content: '(';
}

.author-affiliation::after {
  content: ')';
}

.author-separator {
  width: 4px;
  height: 4px;
  margin: 0 6px;
  border-radius: 999px;
  background: #94a3b8;
  transform: translateY(-3px);
}

.contributors-text {
  margin: 0;
  color: #6b7280;
  font-size: 15px;
  line-height: 1.6;
}

.contributors-text strong {
  color: #334155;
  font-weight: 600;
}

.author-list-block {
  margin-top: 18px;
  padding-top: 4px;
  border-top: 1px solid #eef2ff;
}

.author-list-title {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0 12px;
  color: #475569;
  font-size: 14px;
  font-weight: 600;
}

.author-list-arrow {
  width: 9px;
  height: 9px;
  border-right: 2px solid #64748b;
  border-bottom: 2px solid #64748b;
  transform: rotate(45deg) translateY(-2px);
  transform-origin: center;
}

.affiliations-text {
  padding: 12px 14px;
  background: #fcfcfd;
  border: 1px solid #eaeff8;
  border-radius: 10px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 28px;
  }

  .authors-panel :deep(.ant-card-body) {
    padding: 24px 22px 22px;
  }

  .lead-authors {
    gap: 6px 8px;
    font-size: 15px;
  }

  .author-affiliation {
    font-size: 14px;
  }

  .contributors-text,
  .affiliations-text {
    font-size: 14px;
  }
}

/* 滚动动画 */
.reveal {
  opacity: 0;
  transform: translateY(16px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.reveal.on {
  opacity: 1;
  transform: none;
}
</style>
